import { PhoneFilters } from '../types';
import { isValidIndianMobile } from './phone';

export interface ValidationError {
  field: string;
  message: string;
}

export const validateContact = (values: {
  marathi_name: string;
  name: string;
  phone_number: string;
  shivar: string;
  alternate_phone_number?: string | null;
}): ValidationError[] => {
  const errors: ValidationError[] = [];
  const marathiName = values.marathi_name.trim();
  const name = values.name.trim();
  if (!marathiName) {
    errors.push({ field: 'marathi_name', message: 'Marathi name is required' });
  } else if (marathiName.length < 4) {
    errors.push({ field: 'marathi_name', message: 'Marathi name must be at least 4 characters' });
  }
  if (!name) {
    errors.push({ field: 'name', message: 'Name is required' });
  } else if (name.length < 4) {
    errors.push({ field: 'name', message: 'Name must be at least 4 characters' });
  }
  if (!values.phone_number.trim()) {
    errors.push({ field: 'phone_number', message: 'Phone number is required' });
  } else if (!isValidIndianMobile(values.phone_number)) {
    errors.push({ field: 'phone_number', message: 'Enter a valid 10-digit mobile number starting with 6, 7, 8 or 9' });
  }
  if (!values.shivar.trim()) {
    errors.push({ field: 'shivar', message: 'Shivar is required' });
  }
  if (values.alternate_phone_number && !isValidIndianMobile(values.alternate_phone_number)) {
    errors.push({ field: 'alternate_phone_number', message: 'Enter a valid 10-digit mobile number starting with 6, 7, 8 or 9' });
  }
  return errors;
};

export const validateEmail = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const filterNonEmpty = (filters: PhoneFilters): Record<string, string> => {
  const out: Record<string, string> = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      out[key] = value;
    }
  });
  return out;
};
